// Đây là service TẠM THỜI để phục vụ làm trang profile khi chưa build docker để làm local
// TODO: PHẢI SỬA LẠI
import axiosBase from 'axios';

const axios = axiosBase.create({
	// This is development host
	baseURL: process.env.VUE_APP_URL,
	timeout: 60000,
});

// Constant
const baseUrl = 'user/'

axios.interceptors.request.use(
	function (config) {
		config.headers['Authorization'] = `Bearer ${localStorage.getItem(
			'token'
		)}`;
		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

axios.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		console.log('error', error);
		return Promise.reject(error);
	}
);
const UserTempService = {
	/**
	 * Get user info
	 * @param {Params} userName 
	 * @returns {Response} response
	 */
	async getUserInfo(userName) { 
		try {
			return await axios.get(`/${baseUrl}username/${userName}`);
		} catch (err) {
			throw new Error(`ApiService: ${err}`);
		}
	},
	
	async updateUserInfo(userId, userInfos){
		try {
			return await axios.put(`/${baseUrl}${userId}`, userInfos);
		} catch (err) {
			throw new Error(`ApiService: ${err}`);
		}		
	},
	async getUsernameList(){
		return await axios.get(`/${baseUrl}username`);
	},
	
};

export default UserTempService;